import { SxProps, Theme } from '@mui/material';

export const plpWishListIcon: SxProps<Theme> = (theme) => ({
	borderRadius: '50%',
	backgroundColor: 'white',
	height: '35px',
	width: '35px',
	zIndex: 1,
	padding: '5px',
	boxShadow: `0 3px 6px ${theme.palette.grey['200']}`,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	border: 'none',
	margin: 0,
	WebkitTapHighlightColor: 'transparent',

	'&:active': {
		backgroundColor: 'transparent',
		border: 'none',
		boxShadow: `0 3px 6px ${theme.palette.grey['200']}`,
	},
	'&:hover': {
		backgroundColor: 'transparent',
		border: 'none',
		boxShadow: `0 3px 6px ${theme.palette.grey['200']}`,
	},
	'&:focus': {
		backgroundColor: 'transparent',
		outline: 'none',
		border: 'none',
		boxShadow: `0 3px 6px ${theme.palette.grey['200']}`,
	},
	'&.Mui-focusVisible': {
		backgroundColor: 'transparent',
		outline: 'none',
		boxShadow: `0 3px 6px ${theme.palette.grey['200']}`,
		border: 'none',
	},
});

export const plpWishListContainer = (isMobile?: boolean): SxProps<Theme> => ({
	height: '35px',
	width: '35px',
	position: 'absolute',
	top: 12,
	right: isMobile ? 'auto' : 0,
	left: isMobile ? '120px' : 'auto',
	zIndex: 1,
	marginRight: '15px',
	cursor: 'pointer',
	marginTop: '10px',
	'@media (hover: hover)': {
		'&:hover .hover-line': {
			opacity: 1,
		},
	},
	WebkitTapHighlightColor: 'transparent',
});

export const plpWishListLineDivider: SxProps<Theme> = {
	position: 'absolute',
	bottom: '-8px',
	left: 0,
	right: 0,
	height: '3px',
	backgroundColor: 'primary.main',
	color: 'primary.main',
	opacity: 0,
};
